import script from "./BuyerAutocompleteForBlocking.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyerAutocompleteForBlocking.vue?vue&type=script&setup=true&lang=ts"

import "./BuyerAutocompleteForBlocking.vue?vue&type=style&index=0&id=33b4f442&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b4f442"]])

export default __exports__